import React from 'react';
import { HttpStatusCode } from '@cp/utils/const/httpStatusCode';
import { AppStaticRouterContext } from '../../../routes/model';

export const StaticRouterContext = React.createContext<AppStaticRouterContext>({ statusCode: HttpStatusCode.OK });

export const useStaticRouterContext = () => {
  try {
    return React.useContext(StaticRouterContext);
  } catch {}
};
